// extracted by mini-css-extract-plugin
module.exports = {"sider":"sider_sider__1qNcF","sidebarDesktop":"sider_sidebarDesktop__A05gi","logo":"sider_logo__15KRP","menu":"sider_menu__1wyC_"};